export { Separator, type SeparatorProps } from './Separator';
